import { render, staticRenderFns } from "./occupancyhazard.vue?vue&type=template&id=a8f0f2fc"
import script from "./occupancyhazard.vue?vue&type=script&lang=js"
export * from "./occupancyhazard.vue?vue&type=script&lang=js"
import style0 from "./occupancyhazard.vue?vue&type=style&index=0&id=a8f0f2fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports